import type { ImportGlobFunction } from "vite";

export function isGlobInImportMeta(): boolean {
	try {
		(import.meta as ImportMeta & { glob: ImportGlobFunction }).glob("./*.");
		return true;
	} catch {
		return false;
	}
}
